// Copyright (c) Docugami, Inc. All rights reserved.
const Ltxml = require('../../../../../utils/ltxml.js');

const XName = Ltxml.XName;
const XNamespace = Ltxml.XNamespace;

const dgNs = new XNamespace("http://docugami.com/2020-06-09");
const cpNs = new XNamespace("http://classifyprocess.com/2018/07/");
const xhtmlNs = new XNamespace("http://www.w3.org/1999/xhtml/");

export class DgXmlNames {
    public static dgNs: any = dgNs;
    public static uuid: any = new XName(dgNs + "uuid");

    public static cpNs: any = cpNs;
    public static chunk: any = new XName(cpNs + "chunk");
    public static spanId: any = new XName(cpNs + "spanId");
    public static fromTok: any = new XName(cpNs + "fromTok");
    public static toTok: any = new XName(cpNs + "toTok");
    public static labels: any = new XName("labels");
    public static annotationStreamVersion: any = new XName(cpNs + "annotationStreamVersion");
    public static eventStreamVersion: any = new XName(cpNs + "eventStreamVersion");
    public static version: any = new XName(cpNs + "version");

    public static xhtmlNs: any = xhtmlNs;
    public static div: any = new XName("div");
}
